import { v4 as uuidv4 } from "uuid";

export const sendData = (data, isMobile) => {
  let submitData = { ...data };
  if (!isMobile) {
    if (submitData.tripType === "round_trip") {
      const submissionLocations = submitData.locations.map(
        (location, index) => ({
          ...location,
          ...(index === 1 && { type: "stop", locationType: "stop" }),
        }),
      );

      const departure = submissionLocations[0];
      const { date, time, id, ...baseDeparture } = departure;

      submissionLocations.push({
        ...baseDeparture,
        id: uuidv4(),
        type: "destination",
        locationType: "destination",
      });
      submitData = { ...submitData, locations: submissionLocations };
    }
  }

  sessionStorage.setItem("miniGetAQuoteData", JSON.stringify(submitData));

  window.location.href = "/get-a-quote";
};
